const EMBED_STORAGE_KEY = 'partbay:embed-mode';
const EMBED_HTML_CLASS = 'partbay-embed';
const EMBED_VIEWPORT =
    'width=device-width, initial-scale=1, maximum-scale=1, viewport-fit=cover';

/**
 * Native WebView document setup: lock the root at 16px (so iOS will not
 * auto-zoom focused inputs — ENG-2281's fluid html font-size bottoms out
 * at 12.8px on phones) and pin the viewport scale. Also applied from a
 * matching inline script in `public/index.html` so the first paint is
 * already at the right density.
 */
const applyEmbedDocument = () => {
    if (typeof document === 'undefined') return;
    document.documentElement.classList.add(EMBED_HTML_CLASS);
    const meta = document.querySelector('meta[name="viewport"]');
    if (meta) meta.setAttribute('content', EMBED_VIEWPORT);
};

/**
 * Embed mode (`?embed=1`) — the page is hosted chrome-less inside a native
 * shell (the partbay-mobile Ask Carl WebView). The query param only exists on
 * the initially loaded URL: SPA navigations drop the search string, which
 * previously let in-chat links (e.g. OrderContextCard's "Open order") escape
 * into the full desktop shell with the sidebar. The first sighting of the
 * param is therefore persisted to sessionStorage — scoped to the WebView/tab
 * session — and every check consults both sources.
 */
export const isEmbedMode = (search: string): boolean => {
    const fromQuery = new URLSearchParams(search).get('embed') === '1';
    try {
        if (fromQuery) window.sessionStorage.setItem(EMBED_STORAGE_KEY, '1');
        const embedded = fromQuery || window.sessionStorage.getItem(EMBED_STORAGE_KEY) === '1';
        if (embedded) applyEmbedDocument();
        return embedded;
    } catch {
        // sessionStorage can throw in privacy modes; the query param still works.
        if (fromQuery) applyEmbedDocument();
        return fromQuery;
    }
};
